import styled, { css } from 'styled-components';
import { Chart as ChartComponent } from '../charts.styles';

import { CHART_TITLE_COLOR, MAP_BACKGROUND_COLOR } from '../../../utils/colors';
import { always, equals } from 'ramda';
import { WIDTH_TYPES, ZINDEX } from '../../../utils/constants';
import { propCond } from '../../../utils/propCond';
import { TooltipElementTable as TooltipElementTableComponent } from '../../tooltipElementTable/tooltipElementTable.styles';

const typeCond = propCond('type');

export const Chart = styled(ChartComponent)`
  ${typeCond([
    [
      equals(WIDTH_TYPES.WIDE),
      always(css`
        background-color: ${MAP_BACKGROUND_COLOR};

        &::after,
        &::before {
          content: '';
          position: absolute;
          width: 100vw;
          top: 0;
          height: 100%;
          background-color: ${MAP_BACKGROUND_COLOR};

          z-index: ${ZINDEX.MAP_BACKGROUND};
        }

        &::before {
          left: -100vw;
        }

        &::after {
          right: -100vw;
        }
      `),
    ],
  ])}
`;

export const MapLegend = styled.div`
  color: ${CHART_TITLE_COLOR};
  text-transform: uppercase;
  font-size: 10px;
  position: absolute;
  bottom: 20px;
  left: 0;
  box-shadow: 0 0 16px ${MAP_BACKGROUND_COLOR}b0;
  background-color: ${MAP_BACKGROUND_COLOR}b0;
`;

export const LegendTitle = styled.div`
  line-height: 1em;
  width: 50px;
`;

export const LegendScale = styled.div`
  margin: 5px 0;
  display: flex;
`;

export const CrisisLabels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const LegendBar = styled.div`
  width: 18px;
  margin-right: 5px;
  background: linear-gradient(
    0deg,
    ${({ colors }) => `${colors[0]} 0%, ${colors[1]} 25%, ${colors[2]} 75%, ${colors[3]} 100%`}
  );
`;

export const CrisisBar = styled.div`
  width: 18px;
  height: 108px;
  margin-right: 5px;
  background: linear-gradient(
    0deg,
    ${({ colors }) => `${colors[0]} 0%, ${colors[1]} 25%, ${colors[2]} 75%, ${colors[3]} 100%`}
  );
`;

export const NoScore = styled.div`
  width: 18px;
  height: 18px;
  margin-right: 5px;
  background: #ABABAB;
`;

export const LegendLabels = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LegendItem = styled.div`
  height: 25px;
  width: 20px;
  line-height: 1.05em;
  display: flex;
  align-items: center;
`;

export const TooltipElementTable = styled(TooltipElementTableComponent)`
  && {
    td:nth-child(1) {
      padding-right: 0;
    }
  }

  tr:nth-child(2) {
    display: block;
    padding-top: 20px;
  }
`;
